(function () {
    "use strict";

    angular.module("app.cart").factory("AccountService", AccountService);

    AccountService.$inject = ["$http", "$q"];

    function AccountService($http, $q) {
        var service = {
            getUser: getUser,
            login: login,
            signup: signup,
            getSales: getSales,
            forgotPassword: forgotPassword,
            saveWithoutMemberEmail: saveWithoutMemberEmail,
            removeAccount: removeAccount,
            fastLoginValidate: fastLoginValidate,
            fastLogin: fastLogin
        };

        return service;

        function getUser() {
            var deferred = $q.defer();
            var url = "/api/Account/UserInfo";

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
        function getSales(id) {
            var deferred = $q.defer();
            var url = "/api/Sales/SalesInfo?id=" + id;

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function login(createuser) {
            var deferred = $q.defer();

            $http
                .post("/account/loginajax", createuser)
                .then(loginComplete)
                .catch(loginFailed);

            function loginComplete(response) {
                deferred.resolve(response.data);
            }

            function loginFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function fastLogin(data) {
            var deferred = $q.defer();

            $http
                .post("/webapi/v2/Account/FastLogin", data)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function fastLoginValidate(data) {
            var deferred = $q.defer();

            $http
                .post("/webapi/v2/Account/FastLoginToken", data)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function signup(createuser) {
            var deferred = $q.defer();

            $http
                .post("/account/signupajax", createuser)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function forgotPassword(forgotPasswordData) {
            var deferred = $q.defer();

            $http
                .post("/account/ForgotPasswordAjax", forgotPasswordData)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function saveWithoutMemberEmail(guestEmail) {
            var deferred = $q.defer();

            $http
                .post("/account/saveWithoutMemberEmail?email=" + guestEmail)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
        function removeAccount() {
            var deferred = $q.defer();

            $http.get("/account/removeAccount").then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();
